import sal from 'sal.js';
import Typewriter from 'typewriter-effect/dist/core';

sal();

if (document.getElementById('typewriter')) {
  new Typewriter('#typewriter', {
    strings: [
      'promote your business',
      'explain a product',
      'build your brand',
      'use on Facebook',
      'add to an Instagram story',
      'announce a sale',
    ],
    autoStart: true,
    loop: true,
  });
}

/*
 * Yep its just plain old JS and it saved a 2mb bundle
 * by avoiding react.
 */
const modal = document.getElementById('maker-modal');
const video = document.getElementById('maker-video');

const makerModalOpen = () => {
  modal.setAttribute('data-modal', 'show');
  window.Logger.accessTelemetry().increment(
    'maker.marketingPage.whatIsMakerVideo.open'
  );
  window.addEventListener('keydown', onEscKeyDown);
  modal.addEventListener('click', onOverlayClick);
};

const closeModal = () => {
  modal.setAttribute('data-modal', 'hide');
  // force the video to stop playing
  video.src = video.src;
  window.removeEventListener('keydown', onEscKeyDown);
  modal.removeEventListener('click', onOverlayClick);
};

const onOverlayClick = (event) => {
  if (event.target !== video) {
    closeModal();
  }
};

const onEscKeyDown = (event) => {
  if (event.key === 'Escape') {
    closeModal();
  }
};

window.makerModalOpen = makerModalOpen;
